import React from 'react';

/**
 *  태그가 특정 컨텐츠에 노출여부 체크 텍스트
 */
export const setTagUsedCheckText = (isUsedCheck) => {
  return isUsedCheck ? <span>사용함</span> : <span className="not-use">사용 안함</span>;
};
